var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3590_100692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.834 9.16732H10.834V4.16732C10.834 3.9463 10.7462 3.73434 10.5899 3.57806C10.4336 3.42178 10.2217 3.33398 10.0007 3.33398C9.77964 3.33398 9.56768 3.42178 9.4114 3.57806C9.25512 3.73434 9.16732 3.9463 9.16732 4.16732V9.16732H4.16732C3.9463 9.16732 3.73434 9.25512 3.57806 9.4114C3.42178 9.56768 3.33398 9.77964 3.33398 10.0007C3.33398 10.2217 3.42178 10.4336 3.57806 10.5899C3.73434 10.7462 3.9463 10.834 4.16732 10.834H9.16732V15.834C9.16732 16.055 9.25512 16.267 9.4114 16.4232C9.56768 16.5795 9.77964 16.6673 10.0007 16.6673C10.2217 16.6673 10.4336 16.5795 10.5899 16.4232C10.7462 16.267 10.834 16.055 10.834 15.834V10.834H15.834C16.055 10.834 16.267 10.7462 16.4232 10.5899C16.5795 10.4336 16.6673 10.2217 16.6673 10.0007C16.6673 9.77964 16.5795 9.56768 16.4232 9.4114C16.267 9.25512 16.055 9.16732 15.834 9.16732Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3590_100692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOutline);
export default __webpack_public_path__ + "static/media/plusOutline.949adcecae0e4ff272dc26541b233780.svg";
export { ForwardRef as ReactComponent };